export function getIconName(source) {
  var loweredSource = source.toLowerCase();
  var iconBySource = {
    google: 'google',
    facebook: 'facebook',
    yelp: 'yelp'
  };
  return iconBySource[loweredSource];
}